import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { CommonInputProps, useRecordContext } from 'react-admin';

type EditTitleProps = {
    attributes: string[]
}

export const EditTitle = (props: EditTitleProps) => {
    const record = useRecordContext();
    const {attributes} = props

    return record ? (<Box marginY="10px" display="flex" gap="5px">
            {attributes.map((attr, index) => {

                let nested = attr.split(".")
                if (nested.length > 1) {
                    let name = record[nested[0]]
                    for (let i = 1; i< nested.length; i++) {
                        name= name[nested[i]];
                    }
                    return <Typography key={index} variant="h5">{name ? name : null}</Typography>
                }
                else return <Typography key={index} variant="h5">{record[attr] ? record[attr] : null}</Typography>
            })}
            <Typography variant="h5">({record.id})</Typography>
    </Box>) : null;
}

type CreateTitleProps = {
    source: string
}

export const CreateTitle = (props: CreateTitleProps) => {
    const {source} = props

    return (<Box marginY="10px" display="flex" gap="5px">
            
            <Typography variant="h5">New {source[0].toUpperCase() + source.slice(1).toLocaleLowerCase()}</Typography>
    </Box>);
}